@use "../../scss/breakpoints";
@use "../../scss/colors";

.heroWrapper {
	background-image: url("/img/marketingLayout/backgroundFill.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	// Subtract the height of the header from the screen height
	min-height: calc(100vh - 135px);

	.hero {
		max-width: 1440px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 64px;
		padding: 64px 96px;
		position: relative;
		overflow: hidden;

		@include breakpoints.lg-down {
			padding: 96px 48px;
			gap: 48px;
		}

		@include breakpoints.md-down {
			flex-direction: column;
			padding: 64px 24px;
			gap: 48px;
			align-items: flex-start;
		}

		.primaryCta {
			min-width: 160px;
			min-height: 48px;
			justify-content: center;
			color: colors.$white;
			&:hover,
			&:focus {
				color: colors.$white;
			}
		}

		.secondaryCta {
			min-width: 160px;
			min-height: 48px;
			justify-content: center;
		}
	}
}

.content {
	display: flex;
	flex-direction: column;
	gap: 80px;
	width: 572px;
	max-width: 100%;
	flex-shrink: 0;

	@include breakpoints.md-down {
		gap: 32px;
		width: 100%;
	}
}

.eyebrow {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	padding: 6px 16px;
	border-radius: 999px;
	background: #e5f6f9;
	border: 1px solid #66adde;
	color: colors.$nordic_lake;
	font-family: "GT Eesti Display", sans-serif;
	font-weight: 350;
	font-size: 20px;
	line-height: 28px;
	align-self: flex-start;
	white-space: nowrap;

	.eyebrowDot {
		background: colors.$nordic_lake;
	}
}

.eyebrowOrange {
	background: #ffffee;
	border-color: colors.$nordic_sun;
	color: colors.$nordic_fall;

	.eyebrowDot {
		background: colors.$nordic_fall;
	}
}

.eyebrowGreen {
	background: #f7fbef;
	border-color: colors.$nordic_grass;
	color: #6da646;

	.eyebrowDot {
		background: #6da646;
	}
}

.eyebrowRed {
	background: #fff6f8;
	border-color: #e57a8e;
	color: #b8223f;

	.eyebrowDot {
		background: #b8223f;
	}
}

.eyebrowDot {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	flex-shrink: 0;
}

.copy {
	display: flex;
	flex-direction: column;
	gap: 64px;

	@include breakpoints.md-down {
		gap: 32px;
	}
}

.title {
	font-family: "GT Eesti Display", sans-serif;
	font-weight: 400;
	font-size: 40px;
	line-height: 56px;
	color: #1f2c32;
	margin: 0;

	@include breakpoints.md-down {
		font-size: 32px;
		line-height: 1.2;
	}
}

.body {
	font-family: "GT Eesti Display", sans-serif;
	font-weight: 350;
	font-size: 24px;
	line-height: 32px;
	color: #1f2c32;
	margin: 0;
	max-width: 456px;

	@include breakpoints.md-down {
		font-size: 18px;
		line-height: 1.5;
	}
}

.actions {
	display: flex;
	align-items: center;
	gap: 9px;
	flex-wrap: wrap;
}

.media {
	flex: 1;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	min-width: 0;

	img,
	video,
	picture {
		max-width: 100%;
		height: auto;
	}

	@include breakpoints.md-down {
		width: 100%;
		justify-content: center;
	}
}
